import { render, staticRenderFns } from "./NewsSelect.vue?vue&type=template&id=4205cab7&scoped=true&"
import script from "./NewsSelect.vue?vue&type=script&lang=js&"
export * from "./NewsSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4205cab7",
  null
  
)

export default component.exports